import React, { useState, useEffect } from 'react';
import NoData from '@src/features/common/components/NoData';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { connect } from 'react-redux';
import { IconFont } from '@features/common';
import { SFCItemOption, OrganizeLink, ItemTop } from '@features/common/components';
import { IRootState } from '@src/types';
import { Spin } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { openTargetBlankPage } from '@src/utils';
import { SingleArticleInfo } from '@src/services';
import config from '@src/utils/config';
import actions from '../redux/actions';
import Pinned from './Pinned';

import './Article.less';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

const mapStateToProps = (state: IRootState) => ({
  userInfo: state.common.userInfo
});

interface ISProps {
  data: SingleArticleInfo[];
  isShowHead?: boolean;
  from?: string; // 使用组件处
  loading?: boolean; // 加载状态
  handleDelete?: (businessId: string, articleStatus?: string) => void;
  showOption?: boolean;
  customOption?: React.ReactNode;
  customClick?: (item: SingleArticleInfo) => void;
  className?: string;
  showOrganization?: boolean;
  isAdmin?: boolean;
  /** 是否需要置顶操作 */
  pinned?: boolean;
  /** 置顶函数 */
  articleSticky?: (stickType: number, articleOrQuestionId: number) => void;
}
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & ISProps;

const Article = (props: Props) => {
  const {
    data,
    isShowHead,
    from,
    loading,
    handleDelete,
    showOption,
    customOption,
    customClick,
    className = '',
    isAdmin = false,
    pinned = false,
    articleSticky
  } = props;
  // 是否搜索页面用
  const isFromSearch = from === 'search';

  const toEdit = (item: SingleArticleInfo) => {
    openTargetBlankPage(
      `/article/${item.articleFormatType === 'MARKDOWN' ? 'markdown' : 'edit'}/${item.businessId}`
    );
  };
  const articleStickyTop = (stickType: number, articleOrQuestionId: number) => {
    articleSticky && articleSticky(stickType, articleOrQuestionId);
  };

  return (
    <Spin spinning={loading}>
      <div className={`k-search-home-article ${className}`}>
        {data.map(item => {
          const { id = 0, title, subContent, lastUpdateTime, username, name, createTime } = item;
          // 控制是否打开新标签跳转
          const target = config.enableTargetBlank ? '_blank' : '';

          return (
            <div key={`article${id}`} className="item">
              <div className="left">
                {isShowHead && <p className="head">{name}发表了一篇文章</p>}
                <Link to={`/article/info/${id}`} target={target}>
                  <div className="title">
                    <div className="article-title">
                      <span>{title}</span>
                      {item.isHot && <IconFont type="icon-fire" className="fire" />}
                      {pinned && item.stickFlag === 1 && <Pinned />}
                    </div>
                    {pinned && isAdmin && (
                      <ItemTop
                        id={item.id || 0}
                        stickyFlag={item.stickFlag || 0}
                        stickyFunc={articleStickyTop}
                      />
                    )}
                  </div>
                  <p className="content">{subContent}</p>
                </Link>
                <div className="bottom">
                  <div className="bottom-info">
                    <Link to={`/personal/${username}`} className="author" target={target}>
                      {name}
                    </Link>
                    <OrganizeLink
                      className="author-org"
                      teamInfo={item.teamVO}
                      groupInfo={item.groupVO}
                    />

                    {lastUpdateTime !== createTime ? (
                      <>
                        <div className="splite">|</div>
                        最近更新于
                        <span className="time">{moment(lastUpdateTime).format('MM/DD')}</span>
                      </>
                    ) : (
                      <>
                        <div className="splite">|</div>
                        发布于
                        <span className="time">{moment(createTime).format('MM/DD')}</span>
                      </>
                    )}
                  </div>
                  {showOption && (
                    <SFCItemOption
                      handleRemove={() => {
                        item.id && handleDelete && handleDelete(item.businessId || '', item.status);
                      }}
                      className="options"
                      handleEdit={() => {
                        toEdit(item);
                      }}
                    />
                  )}
                  {customOption && (
                    <div
                      onClick={() => {
                        customClick && customClick(item);
                      }}
                    >
                      {customOption}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        <NoData
          type={isFromSearch ? '1' : ''}
          msg={isFromSearch ? '没找到匹配的结果' : '暂无内容'}
          show={data.length === 0 && loading === false}
        />
      </div>
    </Spin>
  );
};

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(Article);
